import { Col, Form, Input, Row } from "antd"

const AddTagForm = () => {
  return (
    <>
      <Row>
        <Col span={12}>
          <Form.Item name="label" label="Label" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="icon" label="Icon" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item name="id" style={{ display: "none" }}>
        <Input type="hidden" />
      </Form.Item>
    </>
  )
}

export default AddTagForm
